import { Grid } from '@coolblue-development/freddy';

import styles from './Charger.styles';

export default function Icon() {
  return (
    <Grid templateColumns='1fr' sx={styles.icon}>
      {/*This SVG will be replaced with an actual Icon after concept is approved*/}
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M11 0C11.5523 2.41412e-08 12 0.447715 12 1V6H13C13.5523 6 14 6.44772 14 7V7.72949C13.7228 7.85717 13.4651 8.0374 13.2441 8.27148C13.2391 8.27685 13.2335 8.28264 13.2285 8.28809L10.0791 11.7236L8.64453 10.3955C7.7546 9.56721 6.38436 9.51664 5.43652 10.2451L5.25293 10.4023C4.24953 11.3439 4.24951 12.912 5.25293 13.8535L7.54004 16H7C4.23858 16 2 13.7614 2 11V7C2 6.44772 2.44772 6 3 6H4V1C4 0.447715 4.44772 -2.41411e-08 5 0C5.55228 2.41412e-08 6 0.447715 6 1V6H10V1C10 0.447715 10.4477 -2.41411e-08 11 0Z'
          fill='#0090E3'
        />

        <path
          d='M6.75 12 L10 15 L15 9.5'
          fill='none'
          stroke='#00B900'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          style={styles.checkmarkPath}
        />
      </svg>
    </Grid>
  );
}
